export const SystemNotificationsPermissions = {
  GetAllSystemNotifications: 
   {
     permissionsId:'67f97d39-4fc4-4492-b65e-08da535c1c7c',
     permissionsName :'Get All System Notifications',
     componentsId:null,
     components:null
    },
}
